import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from "react";
import { cn } from "../../lib/utils";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(function Input({ className, ...props }, ref) {
  return <input ref={ref} className={cn("h-8 rounded-md border border-slate-300 bg-white px-2 text-xs outline-none focus:border-slate-600", className)} {...props} />;
});

export function Textarea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea className={cn("rounded-md border border-slate-300 bg-white p-2 text-xs outline-none focus:border-slate-600", className)} {...props} />;
}
